// ----------------------------------------------------------------------

function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}


// ----------------------------------------------------------------------
export const ROOT_PATH = '/';

export const PATH_PAGE = {
  page404: '404',
};

export const PATH_CDSS = {
  hypotension: path(ROOT_PATH, 'cdss/hypotension'),
};

export const PATH_AUTH = {
  management: {
    myInfo: path(ROOT_PATH, 'management/my-info'),
    authInfo: path(ROOT_PATH, 'management/auth-info'),
    cutoff: path(ROOT_PATH, 'management/cut-off'),
  }
};